module.exports = __webpack_public_path__ + "img/settings.54fd6c4c.svg";